export default "__VITE_ASSET__BlZNqaR4__"